/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
import {gsap} from 'gsap';
import Matter from 'matter-js';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.navbar-toggle' ).on( 'toggleAfter', ( event ) => {
        $( '.primary-nav' ).slideToggle();
      } );

      $( '.js-init-video' ).magnificPopup( {
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        callbacks: {
          open: function() {
            $( 'video' ).trigger( 'pause' );
          },
          close: function() {
            $( 'video' ).trigger( 'play' );
          },
        },
      } );

      $( '.js-init-content' ).magnificPopup( {
        type: 'inline',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,
        fixedContentPos: false,
        modal: true,
      } );

      $( function() {
        $( 'a[href*="#"]:not(.js-no-scroll):not([href="#"])' ).click( function() {
          if ( location.pathname.replace( /^\//, '' ) === this.pathname.replace( /^\//, '' ) && location.hostname === this.hostname ) {
            let target = $( this.hash );
            let wpadminBarHeight = 0;
            if ( $( '#wpadminbar' ).length > 0 ) {
              wpadminBarHeight = $( '#wpadminbar' ).outerHeight();
            }
            const headerHeight = $( 'header.navbar' ).outerHeight();
            target = target.length ? target : $( '[name=' + this.hash.slice( 1 ) +']' );
            if ( target.length ) {
              $( 'html, body' ).animate( {
                scrollTop: target.offset().top - ( headerHeight + wpadminBarHeight ),
              }, 2000 );
              return false;
            }
          }
        } );
      } );

      $( '.custom-mfp-close' ).on( 'click', function() {
        $.magnificPopup.close();
      } );

      $( document ).on( 'updateMediaQuery', ( event ) => {
        /*
         * Remove any inline display values when the screen changes
         * between mobile and desktop state. This allows the default
         * stylings to kick in and prevent any weird "half mobile half desktop"
         * nav display states that sometimes occur while resizing the browser
         * Also remove any active is-open classes from the toggle and nav to reset
         * its state when switching between screen sizes
         */
        $( '.primary-nav' ).get( 0 ).style.removeProperty( 'display' );
        $( '.navbar-toggle, .primary-nav' ).removeClass( 'is-open' );
      } );

      $( '.squiggle-wrapper, .footer' ).each( function( key, val ) {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: $( this ).find( '.squiggle' )[0],
            start: 'top 75%',
            end: 'bottom 75%',
            scrub: 0,
            refreshPriority: -1,
            onEnter: ( x, y, z ) => {
              $( this ).find( '.squiggle' ).addClass( 'is-loaded' );
            },
          },
        } );
      } );

      $( '.piano button' ).on( 'click', function() {
        const note = new Audio( '/wp-content/themes/adamfichman/assets/sounds/piano/' + $( this ).attr( 'data-note' ) + '.mp3' );
        note.play();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'common', COMPONENT );
} )( app );
